// extracted by mini-css-extract-plugin
export default {"wrapper":"onfido-sdk-ui-ActiveVideo-Wrapper-wrapper"};